export default __webpack_public_path__ + "371dbce0dd46bd4d2033eb2334f28580.svg";